import React from 'react';

export default function Logo() {
  return (
    <svg
      width="122"
      height="105"
      viewBox="0 0 122 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="100.1" cy="20.7706" rx="21.9009" ry="20.7706" fill="white" />
      <ellipse cx="61" cy="84.2295" rx="21.9009" ry="20.7706" fill="white" />
      <ellipse cx="21.9009" cy="20.7706" rx="21.9009" ry="20.7706" fill="white" />
    </svg>
  );
}
